import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'

export function ProfileBox() {
  const { t } = useTranslation(['home', 'common', 'profile'])
  const { parent } = useAuthStore()
  const navigate = useNavigate()

  const handleEditClick = () => {
    navigate('/profile/edit')
  }

  return (
    <>
      {/* Profile Card */}
      <div className="card-neobrutalism">
        <div className="flex items-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-2 text-neobrutalism-text" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <h2 className="text-2xl font-black text-neobrutalism-text">
            {t('profile.title')}
          </h2>
        </div>
        <div className="space-y-2">
          <div className="flex justify-between border-b-2 border-black py-2">
            <span className="font-bold">{t('profile.fields.name')}:</span>
            <span>{parent?.first_name} {parent?.last_name}</span>
          </div>
          <div className="flex justify-between border-b-2 border-black py-2">
            <span className="font-bold">{t('profile.fields.email')}:</span>
            <span>{parent?.email}</span>
          </div>
          {parent?.phones && parent.phones.filter(phone => phone.phone_type === 'mobile').slice(0, 1).map((phone, index) => (
            <div key={index} className="flex justify-between border-b-2 border-black py-2">
              <span className="font-bold">{t(`fields.mobile`, { ns: 'profile' })}:</span>
              <span>{phone.number}</span>
            </div>
          ))}
          <div className="flex justify-between border-b-2 border-black py-2">
            <span className="font-bold">{t('profile.fields.coParent', { ns: 'profile' })}:</span>
            <span>
              {parent?.co_parent 
                ? `${parent.co_parent.first_name} ${parent.co_parent.last_name}` 
                : t('profile.fields.notDefined', { ns: 'profile' })}
            </span>
          </div>
        </div>
        <button 
          onClick={handleEditClick}
          className="btn-neobrutalism bg-neobrutalism-accent block w-full mt-6 text-xs sm:text-base py-2 sm:py-3 px-2 sm:px-4"
        >
          {t('profile.editButton')}
        </button>
      </div>
    </>
  )
} 